import { ComponentSlotStyle, Flex } from '@fluentui/react-northstar';
import { IImageStyles } from '@fluentui/react/lib/Image';
import { FontWeights, IStyle, ITheme, mergeStyles } from '@fluentui/react/lib/Styling';
import { ITextStyles } from '@fluentui/react/lib/Text';
const ErrorPageStyle = mergeStyles({
  width: '100%',
height:"100%",
display:'flex',
// alignItems:"center",
paddingTop:"100px",
justifyContent:'center',
".col-md-12":{
    display:'flex',
alignItems:"center",
justifyContent:'center',
}
});
 const getImageStyles = (theme: ITheme): Partial<IImageStyles> => {
    return {
      root: {
        maxWidth: '100vw',
      },
    };
  };
 const getMessageStyles = (theme: ITheme): IStyle => {
    return {
      fontFamily: 'Segoe UI',
      height: 'auto',
    };
  };
 const getTextStyles = (theme: ITheme): Partial<ITextStyles> => {
    return {
      root: mergeStyles(getMessageStyles(theme), {
        maxWidth: 552,
        textAlign: 'center',
      }),
    };
  };
const chatAvatarStyle = (isShow: boolean): ComponentSlotStyle => ({
  display: isShow ? 'block' : 'none',
  position: 'absolute',
  top: '11px',
  left: '49px'
});

export {
    getImageStyles,
    getTextStyles,
    ErrorPageStyle,
  chatAvatarStyle
};
